import {
  Layout,
  PageHeader,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Button,
  Radio,
  Spin,
  Card,
  Space,
  Modal,
  Avatar,
  Select,
  Checkbox,
} from "antd";
import {
  PlusCircleOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import logo from "assets/delphy/Delphi.svg";
import "./EpcSelfServingOnBoarding.less";
import { v4 as uuidv4 } from "uuid";
import { Content } from "antd/lib/layout/layout";
import SkeletonBlock from "utility/SkeletonBlocks";
import { useEffect, useState } from "react";
import {
  cityPattern,
  emailPattern,
  formatNumberUS,
  namePattern,
  servicesNamePattern,
  specialPatternOnboarding,
  streetAddressPattern,
  tenDigit,
  zipPattern,
} from "utility/constant";
import moment from "moment";
import awsmobile from "aws-exports";
import { API } from "aws-amplify";
import { getDoctorCustom, listDoctorCustom } from "graphql/customQuery";
import { ListBillingPlansSelfServing } from "utility/action";
import { loadStripe } from "@stripe/stripe-js";

import FormDatePicker from "components/common/FormDatePicker";
import { useLocation, useParams } from "react-router-dom";
import { disabledDate, specialDoctorID } from "utils/general";
const { TextArea } = Input;

export const EpcSelfServingOnBoarding = () => {
  const stripePromise = loadStripe(`${process.env.REACT_APP_EPC_STRIPE}`);
  const [stripe, setStripe] = useState([]);
  const [skeletonLoader, setskeletonLoader] = useState(false);
  const [doctorName, setDoctorName] = useState(null);
  const [doctorID, setDoctorID] = useState(null);
  const [doctorStartDate, setDoctorStartDate] = useState(null);
  const [nameLoader, setNameLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [planChange, setPlanChange] = useState(null);
  const [planPrice, setPlanPrice] = useState([120, 1440]);
  const [modal, setModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentDependent, setCurrentDependent] = useState(null);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [depForm] = Form.useForm();
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [dependantDetails, setDependantDetails] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [patient, setPatient] = useState(false); // default value is false
  const { id } = useParams(""); // doctorId
  const dpcDoctorID = id;
  const initialDoctorId =
    doctorList?.find((d) => d?.doctorName === selectedDoctor)?.id || null;
  const onPlanChange = (e) => {
    setPlanChange(e.target.value);
  };

  const referralSources = [
    "Search Engine (Google, Bing, etc.)",
    "Jack Health Radio",
    "Radio",
    "Mailer",
    "Magazine/Newspaper Article",
    "Social Media",
    "Word of Mouth",
    "Referral",
    "Friends or Family",
    "Other",
  ];

  const openAddModal = async () => {
    if (doctorList.length === 0) {
      const responce = await API.graphql({
        query: listDoctorCustom,
        variables: {
          filter: { isDpcDoctor: { eq: true }, activeOnPortal: { eq: true } },
          limit: "9999",
        },
        authMode: "API_KEY",
        authToken: awsmobile.aws_appsync_apiKey,
      });
      setDoctorList(responce?.data?.listDoctorProfiles?.items);
    }
    setIsEditMode(false);
    depForm.resetFields();
    setModal(true);
  };

  const openEditModal = (dependent) => {
    setIsEditMode(true);
    setCurrentDependent(dependent);
    console.log(dependent, "sdfsd");
    depForm.setFieldsValue({
      firstName: dependent.firstName,
      lastName: dependent.lastName,
      email: dependent.email,
      phone: dependent.phoneNumber,
      dob: moment(dependent.dob),
      doctor: dependent.doctorDetails,
    });
    setModal(true);
  };

  const removeDependent = (id) => {
    setDependantDetails(
      dependantDetails.filter((dependent) => dependent.id !== id)
    );
  };

  const handleModalDestroy = () => {
    depForm.resetFields();
  };

  const onChange = (e) => {
    setPatient(e.target.checked);
  };

  const handleDependentAddition = async (values) => {
    const filteredDoctor = doctorList.find(
      (doctor) => doctor.doctorName === values?.doctor
    );
    let doctorJson;
    if (filteredDoctor) {
      // Create a new object with selected fields and additional properties
      doctorJson = {
        name: filteredDoctor.doctorName,
        id: filteredDoctor.id,
        startDate: filteredDoctor.startDate,
      };
    }
    const date = moment(values.dob).format("YYYY-MM-DD");
    if (isEditMode && currentDependent) {
      const updatedList = dependantDetails.map((dep) =>
        dep.id === currentDependent.id
          ? {
              ...dep,
              ...values,
              fistName: values.firstName.trim(),
              lastName: values.lastName.trim(),
              phoneNumber: values.phone,
              dob: date,
              doctorDetails: doctorJson?.name,
              doctorID: doctorJson?.id,
              startDate: doctorJson?.startDate,
            }
          : dep
      );
      setDependantDetails(updatedList);
    } else {
      const newDependent = {
        id: uuidv4(),
        firstName: (values?.firstName).trim(),
        lastName: (values?.lastName).trim(),
        email: values.email,
        phoneNumber: values.phone,
        dob: date,
        doctorDetails: doctorJson?.name,
        doctorID: doctorJson?.id,
        startDate: doctorJson?.startDate,
      };
      setDependantDetails((prevList) => [...prevList, newDependent]);
    }
    setModal(false);
  };

  const AddSpouseOrDependent = () => {
    return (
      <Card
        bordered
        style={{
          margin: "0 auto 20px",
          border: "1px dashed #B6CCD7",
        }}
        size="small"
      >
        <Space
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div class="column-container">
            <span
              style={{
                fontSize: "15px",
                fontWeight: "500",
                marginRight: "10px",
                lineHeight: "20px",
                color: "#00274C",
              }}
            >
              Will You be Adding a Spouse or Additional Member(s)?
            </span>
            <br />
            <span
              style={{
                fontSize: "11px",
                fontWeight: "300",
                marginRight: "10px",
                lineHeight: "20px",
                color: "#00274C",
                fontStyle: "italic",
              }}
            >
              The first dependent gets a 10% discount, and subsequent dependents
              receive a 20% discount.
            </span>
          </div>
          <Button
            type="dashed"
            icon={<PlusCircleOutlined style={{ color: "#00274C" }} />}
            style={{
              backgroundColor: "#E8EEF1",
            }}
            onClick={() => openAddModal()}
          >
            Yes want to add
          </Button>
        </Space>
      </Card>
    );
  };

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);

      if (!planChange) {
        messageApi.open({
          type: "error",
          content: "Please Select Plan",
        });
        setLoading(false);
        return;
      }

      if (dependantDetails.length === 0 && !patient) {
        messageApi.open({
          type: "error",
          content:
            "You must sign up as a patient or add at least one dependent before proceeding.",
        });
        setLoading(false);
        return;
      }

      const res = await ListBillingPlansSelfServing({
        name: { contains: "DPC" },
      });

      const planArray = await Promise.all(
        res?.filter((param) => {
          const details = JSON.parse(param?.planDetails);
          return details?.planName === planChange;
        })
      );

      const obj = JSON.parse(planArray[0].planDetails);
      console.log(obj?.stripePriceId, planArray[0].id);

      const payloadData = {};

      payloadData["parentDetails"] = {
        firstName: (values?.firstName).trim(),
        lastName: (values?.lastName).trim(),
        dob: values?.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
        email: values?.email,
        phoneNumber: values?.phone,
        streetAddress: values?.streetAddress,
        city: values?.city,
        state: values?.state,
        zipCode: values?.zip,
        insuranceCarrier: (values?.insuranceCarrier).trim(),
        reference: !isOtherSelected
          ? values?.reference
          : values?.otherReference,
        question: values?.questions,
        doctorID: doctorID,
        startDate: doctorStartDate,
      };
      payloadData["dependentDetails"] = dependantDetails;
      payloadData["isPatient"] = patient;
      const myInit = {
        body: {
          payloadData,
          planId: planArray[0].id,
          stripePriceId: obj?.stripePriceId,
        },
      };

      const sessionResult = await API.post(
        "bazarhealthREST",
        `/selfServingOnboarding/${doctorID}`,
        myInit
      );

      if (sessionResult.type === "checkout" && sessionResult.sessionId) {
        stripe
          .redirectToCheckout({
            sessionId: sessionResult.sessionId,
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        console.log("err");
      }
      setLoading(false);
    } catch (error) {
      console.log(error, "error");
      setLoading(false);

      messageApi.open({
        type: "error",
        content: error?.response?.data?.error || "Something went wrong!",
      });
    }
  };

  async function fetchDoctorDetails(id) {
    setskeletonLoader(true);
    setNameLoader(true);

    const response = await API.graphql({
      query: getDoctorCustom,
      variables: {
        id,
      },
      authMode: "API_KEY",
      authToken: awsmobile.aws_appsync_apiKey,
    });
    if (!response?.data?.getDoctorProfile?.id) {
      //handle if no id is found
    }
    setDoctorStartDate(response?.data?.getDoctorProfile?.startDate);
    setDoctorName("Join " + response?.data?.getDoctorProfile?.doctorName);
    setNameLoader(false);
    setskeletonLoader(false);
  }

  const resolveStripe = async () => {
    let s = await stripePromise;
    setStripe(s);
  };

  useEffect(() => {
    resolveStripe();
    const currentUrl = new URL(window.location.href);
    const pathParts = currentUrl?.pathname?.split("/");
    const lastNumber = pathParts[pathParts.length - 1];
    setDoctorID(lastNumber);

    fetchDoctorDetails(lastNumber);
  }, []);

  useEffect(() => {
    const baseMonthlyPrice = 120; // Parent
    const baseYearlyPrice = 1440;
    const firstDependentMonthly = baseMonthlyPrice * 0.9; // 10% off
    const firstDependentYearly = baseYearlyPrice * 0.9;
    const additionalDependentMonthly = baseMonthlyPrice * 0.8; // 20% off
    const additionalDependentYearly = baseYearlyPrice * 0.8;

    const dependents = dependantDetails.length;
    let totalMonthlyPrice = 0;
    let totalYearlyPrice = 0;

    if (patient) {
      // ✅ Current flow
      totalMonthlyPrice = baseMonthlyPrice;
      totalYearlyPrice = baseYearlyPrice;

      if (dependents > 0) {
        totalMonthlyPrice += firstDependentMonthly;
        totalYearlyPrice += firstDependentYearly;
        if (dependents > 1) {
          totalMonthlyPrice += (dependents - 1) * additionalDependentMonthly;
          totalYearlyPrice += (dependents - 1) * additionalDependentYearly;
        }
      }
    } else {
      if (dependents === 0) {
        // If no dependents, still show full base plan price
        totalMonthlyPrice = baseMonthlyPrice;
        totalYearlyPrice = baseYearlyPrice;
      } else {
        // ❌ Parent removed, first dependent is full price
        totalMonthlyPrice = baseMonthlyPrice;
        totalYearlyPrice = baseYearlyPrice;

        if (dependents > 1) {
          // Second dependent gets 10%
          totalMonthlyPrice += firstDependentMonthly;
          totalYearlyPrice += firstDependentYearly;
        }

        if (dependents > 2) {
          // Remaining dependents get 20%
          totalMonthlyPrice += (dependents - 2) * additionalDependentMonthly;
          totalYearlyPrice += (dependents - 2) * additionalDependentYearly;
        }
      }
    }

    setPlanPrice([totalMonthlyPrice, totalYearlyPrice]);
  }, [dependantDetails, patient]);

  return (
    <>
      {contextHolder}
      <Layout>
        <PageHeader style={{ backgroundColor: "#CEE1ED" }}>
          <Row className="onboarding-page" justify="center" align="middle">
            <Col span={24} className="responsive-mt-20">
              <img src={logo} alt="Bazar Logo" className="bazar-logo" />
            </Col>
          </Row>
          <Row
            className="onboarding-page"
            justify="center"
            align="middle"
            style={{ padding: "25px", color: "#00274C" }}
          >
            <h2
              style={{
                fontWeight: "700",
                fontSize: "30px",
                lineHeight: "24px",
                color: "#00274C",
              }}
            >
              {" "}
              <Spin size="large" spinning={nameLoader}>
                {doctorName || ""}
              </Spin>
            </h2>
          </Row>
        </PageHeader>
        <Content style={{ backgroundColor: "#F3F9FD" }}>
          <Row justify="center" className="update-form">
            <Col span={16} md={16} xs={24} sm={24} style={{ maxWidth: "55%" }}>
              {skeletonLoader ? (
                <>
                  <Row gutter={[20, 20]} className="mt-3">
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 50 }} />
                    <SkeletonBlock style={{ width: "100%", height: 200 }} />
                  </Row>
                </>
              ) : (
                <>
                  <Form
                    name="basic"
                    form={form}
                    onFinish={handleFormSubmit}
                    autoComplete="off"
                    layout="vertical"
                    className="mt-20"
                    validateFirst={true}
                  >
                    <Row gutter={20}>
                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px", // small space between label & checkbox
                            background: "#e6f4ff",
                            padding: "8px 12px",
                            borderRadius: "6px",
                            marginBottom: "10px",
                          }}
                        >
                          <span
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              padding: "4px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            Account Holder
                          </span>

                          <Checkbox checked={patient} onChange={onChange}>
                            I am signing up as a patient
                          </Checkbox>
                        </div>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="First Name"
                          name="firstName"
                          required
                          validateFirst={true}
                          rules={[
                            {
                              required: true,
                              message: "Please input your first name!",
                            },
                            {
                              pattern: /^[A-Za-z]*(?: [A-Za-z]+)*$/,
                              message: "Name can only contain alphabets",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Last Name"
                          name="lastName"
                          required
                          validateFirst={true}
                          rules={[
                            {
                              required: true,
                              message: "Please input your last name!",
                            },
                            {
                              pattern: /^[A-Za-z]*(?: [A-Za-z]+)*$/,
                              message: "Name can only contain alphabets",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={24} xs={24} sm={24}>
                        <div
                          className="referral-code mb-20"
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <span
                            className="referral-code"
                            style={{
                              fontWeight: "500",
                              fontSize: "15px",
                              lineHeight: "20px",
                              color: "#00274C",
                            }}
                          >
                            {" "}
                            You will be charged *
                          </span>
                          <Row
                            className="billing-cards-invite-dpc"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px", // spacing between radios
                              flexWrap: "wrap", // allow wrapping on small screens
                              marginTop: "10px",
                            }}
                          >
                            <Radio
                              value="DPC_MONTHLY"
                              onChange={onPlanChange}
                              checked={planChange === "DPC_MONTHLY"}
                            >
                              <span
                                className={`pricing `}
                                style={{
                                  fontWeight: "700",
                                  fontSize: "25px",
                                  lineHeight: "35px",
                                  color: "#00274C",
                                  display: "inline-block",
                                  marginRight: "5px",
                                }}
                              >
                                ${planPrice[0]}
                              </span>{" "}
                              {"/Month "}
                            </Radio>
                            <Radio
                              value="DPC_ANNUALLY"
                              onChange={onPlanChange}
                              checked={planChange === "DPC_ANNUALLY"}
                            >
                              <span
                                className={`pricing `}
                                style={{
                                  fontWeight: "700",
                                  fontSize: "25px",
                                  lineHeight: "35px",
                                  color: "#00274C",
                                  display: "inline-block",
                                  marginRight: "5px",
                                }}
                              >
                                ${planPrice[1]}
                              </span>
                              /Year
                            </Radio>
                          </Row>
                        </div>
                      </Col>
                      <Col span={12} md={24} xs={24} sm={24}>
                        {dependantDetails.length === 0 ? (
                          AddSpouseOrDependent()
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              gap: "16px",
                              alignItems: "center",
                              justifyContent: "flex-start", // left align, so scroll works
                              padding: "20px",
                              flexWrap: "nowrap", // no wrapping, keep items in one line
                              overflowX: "auto", // horizontal scroll
                              overflowY: "hidden", // hide vertical scroll
                              scrollbarWidth: "thin", // Firefox
                            }}
                          >
                            {dependantDetails.map((dependent) => (
                              <Card
                                key={dependent.id}
                                className={"fdfd"}
                                size="small"
                                style={{
                                  width: 150,
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  position: "relative",
                                }}
                                onClick={(event) => {
                                  if (
                                    event.target.classList.contains(
                                      "ant-card-body"
                                    )
                                  ) {
                                    // Ignore click if it was on the icon
                                    openEditModal(dependent);
                                    return;
                                  }
                                }}
                              >
                                <CloseCircleOutlined
                                  style={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    cursor: "pointer",
                                    color: "#ff4d4f",
                                  }}
                                  className="closeCircleOutlined"
                                  id="fdsfd"
                                  onClick={() => removeDependent(dependent.id)}
                                />
                                <Avatar
                                  size={48}
                                  icon={<UserOutlined />}
                                  //   style={{ marginBottom: "10px" }}
                                />
                                <p
                                  style={{
                                    margin: "5px 0",
                                    color: "#00274C",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {`${dependent.firstName || ""} ${
                                    dependent.lastName || ""
                                  }`}
                                </p>
                                <p
                                  style={{
                                    margin: "5px 0",
                                    fontSize: "12px",
                                    color: "#888",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "wrap",
                                    maxWidth: "130px",
                                  }}
                                >
                                  {dependent.email}
                                </p>
                              </Card>
                            ))}
                            {dependantDetails.length < 5 && (
                              <Card
                                style={{
                                  width: 150,
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  backgroundColor: "transparent",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                                onClick={() => openAddModal()}
                              >
                                <PlusOutlined
                                  style={{ fontSize: 32, color: "#00274C" }}
                                />
                                <p
                                  style={{
                                    margin: "5px 0",
                                    fontWeight: "bold",
                                    color: "#00274C",
                                  }}
                                >
                                  Add More
                                </p>
                              </Card>
                            )}
                          </div>
                        )}
                      </Col>

                      <Col span={12} md={12} xs={24} sm={24}>
                        <FormDatePicker
                          name="dob"
                          label="Date of Birth"
                          disabledDate={disabledDate}
                          doctorId={dpcDoctorID}
                          defaultPickerValue={moment()}
                        />
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "Please input your email!",
                            },
                            {
                              pattern: emailPattern,
                              message: "Please enter a valid email",
                            },
                          ]}
                        >
                          <Input placeholder="email@email.com" />
                        </Form.Item>
                      </Col>

                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Cell Phone Number"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: "Please input your phone number!",
                            },
                            {
                              pattern: tenDigit,
                              message: "Please enter a valid phone number",
                            },
                          ]}
                        >
                          <InputNumber
                            controls={false}
                            placeholder="(111) 111-1111"
                            formatter={(value) => formatNumberUS(value)}
                            parser={(value) => {
                              const cleanedValue = value?.replace(/\D/g, "");
                              return cleanedValue.slice(0, 10);
                            }}
                            style={{ width: "100%", borderRadius: "5px" }}
                            maxLength={14}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Street Address"
                          name="streetAddress"
                          rules={[
                            {
                              required: true,
                              message: "Please input your street address!",
                            },
                            {
                              pattern: streetAddressPattern,
                              message: "Please enter a valid street address",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="City"
                          name="city"
                          rules={[
                            {
                              required: true,
                              message: "Please input your city!",
                            },
                            {
                              pattern: cityPattern,
                              message: "Please enter a valid city name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="State"
                          name="state"
                          rules={[
                            {
                              required: true,
                              message: "Please input your state!",
                            },
                            {
                              pattern: cityPattern,
                              message: "Please enter a valid state name",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Zip Code"
                          name="zip"
                          rules={[
                            {
                              required: true,
                              message: "Please input your zip code!",
                            },
                            {
                              pattern: zipPattern,
                              message: "Please enter a valid ZIP code",
                            },
                          ]}
                        >
                          <Input maxLength={5} />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24} sm={24}>
                        <Form.Item
                          label="Insurance Carrier"
                          name="insuranceCarrier"
                          rules={[
                            {
                              required: true,
                              message: "Please input your insurance carrier!",
                            },
                            {
                              pattern: specialPatternOnboarding,
                              message: "Please enter a valid insurance carrier",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={24} xs={24} sm={24}>
                        <Form.Item
                          label="How did you hear about us?"
                          name="reference"
                          rules={[
                            {
                              required: true,
                              message: "Required!",
                            },
                          ]}
                        >
                          {/* <Input /> */}
                          <Select
                            allowClear
                            placeholder="How did you hear about us?"
                            onChange={(value) => {
                              //Added a timer as their was some jerk in screen as select closes and the new input field opens or vice-versa
                              setTimeout(
                                () => setIsOtherSelected(value === "Other"),
                                400
                              );
                            }}
                          >
                            {referralSources.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item} //have start date too, once it is done.
                              >{`${item}`}</Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {isOtherSelected && (
                          <Form.Item
                            label="Please specify"
                            name="otherReference"
                            validateFirst={true}
                            rules={[
                              {
                                required: true,
                                message: "Please specify the reference!",
                              },
                              {
                                pattern: /^(?=.*\S).*$/, // Rule 1: Prevent only white space
                                message:
                                  "Input cannot be empty or just white spaces.",
                              },
                              {
                                pattern: /^(?=.*[a-zA-Z]).*$/, // Ensure input contains alphabets
                                message:
                                  "Input must include at least one alphabet.", // Third validation rule
                              },
                            ]}
                          >
                            <Input placeholder="Specify your answer" />
                          </Form.Item>
                        )}
                      </Col>
                      <Col span={12} md={24} xs={24} sm={24}>
                        <Form.Item label="Questions?" name="questions">
                          <TextArea rows={4} />
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        md={24}
                        xs={24}
                        sm={24}
                        style={{ textAlign: "center" }}
                      >
                        <Button
                          size="large"
                          className="theme-btn"
                          htmlType="submit"
                          style={{ margin: "5px" }}
                          loading={loading}
                        >
                          Proceed to Checkout
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </>
              )}
            </Col>
          </Row>
        </Content>
      </Layout>

      <Modal
        title={"Add Spouse or Additional Member"}
        width={600}
        open={modal}
        onCancel={() => {
          setModal(false);
        }}
        keyboard={false}
        centered
        className="form-modal inv-second-step desired-modal"
        footer={null}
        afterClose={handleModalDestroy}
      >
        <Form
          name="employee"
          onFinish={handleDependentAddition}
          autoComplete="off"
          id="memberInvite"
          layout="vertical"
          form={depForm}
        >
          <Row gutter={20}>
            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please enter first name!",
                  },
                  {
                    pattern: specialPatternOnboarding,
                    message: "Please enter a valid first name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Please enter last name!",
                  },

                  {
                    pattern: specialPatternOnboarding,
                    message: "Please enter a valid last name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter email",
                  },
                  {
                    pattern: emailPattern,
                    message: "Please enter a valid email",
                  },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const trimmedEmail = value.trim().toLowerCase();
                      const isDuplicate = dependantDetails.some(
                        (dep) =>
                          dep.email?.trim().toLowerCase() === trimmedEmail &&
                          (!isEditMode || dep.id !== currentDependent?.id)
                      );

                      if (isDuplicate) {
                        return Promise.reject("This Email is already added");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Phone"
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                  {
                    pattern: tenDigit,
                    message: "Please enter a valid phone number",
                  },
                ]}
              >
                <InputNumber
                  controls={false}
                  placeholder="(111) 111-1111"
                  formatter={(value) => formatNumberUS(value)}
                  parser={(value) => {
                    const cleanedValue = value?.replace(/\D/g, "");
                    return cleanedValue.slice(0, 10);
                  }}
                  style={{ width: "100%", borderRadius: "5px" }}
                  maxLength={14}
                />
              </Form.Item>
            </Col>

            <Col span={12} md={12} xs={24} sm={24}>
              <FormDatePicker
                name="dob"
                label="Date of Birth"
                disabledDate={disabledDate}
                doctorId={isSelected ? initialDoctorId : dpcDoctorID}
                defaultPickerValue={moment()}
              />
            </Col>
            <Col span={12} md={12} xs={24} sm={24}>
              <Form.Item
                label="Choose Your Medical Provider"
                name="doctor"
                initialValue={doctorName?.replace("Join ", "")}
                rules={[
                  {
                    required: true,
                    message: "Please select any doctor",
                  },
                ]}
              >
                <Select
                  allowClear
                  placeholder="Select Employer"
                  value={doctorName?.replace("Join ", "")}
                  onChange={(value) => {
                    setSelectedDoctor(value);
                    setIsSelected(true);
                  }}
                >
                  {/*
                    Temporary logic for handling the special doctor (Dr. Boucher) until December 1st:
                    1. By default, show all doctors except the one with `specialDoctorID` (Dr. Boucher).
                    2. If the query parameter contains `specialDoctorID`, then only show that doctor.
                    TODO: Remove this conditional logic after December 1st.
                  */}
                  {/*{doctorList.map((item) => (
                    <Select.Option
                      key={item?.id}
                      value={item?.doctorName} //have start date too, once it is done.
                    >{`${item.doctorName}`}</Select.Option>
                  ))} */}
                  {(id === specialDoctorID
                    ? doctorList.filter((doc) => doc.id === specialDoctorID) // show only that doctor
                    : doctorList.filter((doc) => doc.id !== specialDoctorID)
                  ) // show all except that doctor
                    .map((item) => (
                      <Select.Option key={item?.id} value={item?.doctorName}>
                        {item?.doctorName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              span={12}
              md={24}
              xs={24}
              sm={24}
              style={{ textAlign: "center" }}
            >
              <Button
                type="primary"
                className="theme-btn inv-third-step"
                htmlType="submit"
                loading={loading}
                style={{ marginTop: "0px !important" }}
              >
                Add Member
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
